const c = "_circle_1gniq_1", e = {
  circle: c
};
export {
  c as circle,
  e as default
};
